import React from "react";
import { PageHero, CTA } from "@/components/PageHero";
import { SERVICES } from "@/data/site";
import { useSEO } from "@/hooks/useSEO";

export default function Services() {
  useSEO({
    title: "Services — Easyworks Industries Pvt. Ltd.",
    description: "Easyworks Industries services: website development, e-commerce, custom software, mobile apps, AI automation, ERP & CRM, cloud & DevOps, UI/UX, digital marketing and 24/7 support.",
  });
  return (
    <div data-testid="services-page">
      <PageHero title="Our Services" subtitle="From websites to enterprise software, AI to cloud – we deliver everything your business needs to scale." />
      <section className="py-20">
        <div className="container mx-auto max-w-7xl px-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {SERVICES.map((s) => {
            const Icon = s.icon;
            return (
              <div key={s.key} className="p-6 rounded-xl border border-slate-200 hover:border-blue-200 hover:shadow-lg hover:shadow-blue-900/5 hover:-translate-y-1 transition-all duration-300" data-testid={`services-page-card-${s.key}`}>
                <div className="w-11 h-11 rounded-md bg-blue-50 border border-blue-100 flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-[#2563EB]" />
                </div>
                <h3 className="font-semibold text-slate-900 mb-2" style={{ fontFamily: "Outfit" }}>{s.title}</h3>
                <p className="text-[13.5px] text-slate-500 leading-relaxed">{s.desc}</p>
              </div>
            );
          })}
        </div>
      </section>
      <CTA />
    </div>
  );
}
